// Patch EulerBeats.audio to support playing MP3 from URL

import EB, { getChords, isChordEvent, ThemeEvent } from './EulerBeatsWrapper';

export {};

patchGenesis();
patchEnigma();

function patchGenesis() {
  const EBA = window.EulerBeatsGenesis.audio;
  const EBV = window.EulerBeatsGenesis.visual;
  patchAudioStop(EBA);
  EBA.options.remoteCacheEnabled = true;
  EBA.options.remoteCacheBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL || '/assets';
  EBA.options.remoteCacheExtension = 'mp3';
  const EBA_playInternal = EBA.playInternal;
  EBA.playInternal = async (theme, decodedSeed) => {
    EBA.stop();
    EB.audio.chords = getChords(theme);
    const url = `${EBA.options.remoteCacheBaseUrl}/${decodedSeed.originalSeed}.${EBA.options.remoteCacheExtension}`;
    if (EBA.options.remoteCacheEnabled && (await urlExists(url))) {
      console.log('Playing', decodedSeed.originalSeed, decodedSeed);
      const firstTrackStart = Math.min(...Object.values(theme.tracks).map((t: any) => t.start));
      const startDelay = (EBA.startDelay() + firstTrackStart) * 1000;
      await playAudio(startDelay, url, EBA);
    } else {
      await EBA_playInternal(theme, decodedSeed);
    }
  };

  const EBV_eventsHandler = EBV.eventsHandler;
  EBV.eventsHandler = (e: { event: ThemeEvent }) => {
    if (isChordEvent(e.event)) {
      EB.audio.lastChordEventIndex = e.event.index;
    }
    EBV_eventsHandler(e);
  };
}

function patchEnigma() {
  const EBA = window.EulerBeatsEnigma.audio;
  const EBV = window.EulerBeatsEnigma.visual;
  patchAudioStop(EBA);
  EBA.options.remoteCacheEnabled = true;
  EBA.options.remoteCacheBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL + '/enigma' || '/assets';
  EBA.options.remoteCacheExtension = 'mp3';
  const EBA_playInternal = EBA.playInternal;
  EBA.playInternal = async (theme, decodedSeed) => {
    EBA.stop();
    EB.audio.chords = getChords(theme);
    const url = `${EBA.options.remoteCacheBaseUrl}/${decodedSeed.originalSeed}.${EBA.options.remoteCacheExtension}`;
    if (EBA.options.remoteCacheEnabled && (await urlExists(url))) {
      console.log('Playing', decodedSeed.originalSeed, decodedSeed);
      const startDelay = EBA.startDelay() * 1000;
      await playAudio(startDelay, url, EBA);
    } else {
      await EBA_playInternal(theme, decodedSeed);
    }
  };

  const EBV_eventsHandler = EBV.eventsHandler;
  EBV.eventsHandler = (e: { event: ThemeEvent }) => {
    if (isChordEvent(e.event)) {
      EB.audio.lastChordEventIndex = e.event.index;
    }
    EBV_eventsHandler(e);
  };
}

function patchAudioStop(EBA) {
  const EBA_stop = EBA.stop;
  EBA.stop = () => {
    if (EB.audio.player) {
      EB.audio.player.pause();
      EB.audio.player = null;
    }
    EBA_stop();
  };
}

function playAudio(startDelay, url, EBA) {
  return new Promise((resolve: Function, _) => {
    EB.audio.player = new Audio();
    // Wait for enough data buffered...
    EB.audio.player.addEventListener('canplaythrough', () => {
      // This assumes all silence has been stripped from the start of the audio file.
      setTimeout(() => {
        EB.audio.player?.play().catch(console.error);
      }, startDelay);
      resolve();
    });
    const nonStandardPlayer: any = EB.audio.player;
    nonStandardPlayer.preservesPitch = true;
    nonStandardPlayer.mozPreservesPitch = true;
    nonStandardPlayer.webkitPreservesPitch = true;
    EB.audio.player.src = url;
    EB.audio.player.load(); // required on iOS

    EB.audio.player.addEventListener('loadedmetadata', () => {
      if (!EB.audio.player) {
        return;
      }
      // adjust playback rate and currentTime
      EB.audio.updatePlaybackRate(EB.audio.playbackRate);
      if (EB.audio.currentTimePercentage != null) {
        EB.audio.updateCurrentTimePercentage(EB.audio.currentTimePercentage);
      }
    });
  });
}

function urlExists(url: string) {
  return new Promise((resolve, _) => {
    var request = new XMLHttpRequest();
    request.open('HEAD', url, true);
    request.send();
    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        resolve(request.status === 200);
      }
    };
  });
}
